import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class Sorting {
    constructor() {}

    public compare(str1: string, str2: string): number {
        if (str1 > str2) {
            return 1;
        } else if (str1 < str2) {
            return -1;
        } else return 0;
    }
}